export default "__VITE_ASSET__CsIyF_GM__"